import {useContext} from "react";

import {
    MathEditorAPIContext,
    type MathEditorAPI,
} from "./math-editor-context.ts";

/**
 * Hook providing an API for updating the external state of the MathEditor.
 */
export const useMathEditorAPIContext = (): MathEditorAPI =>
    useContext(MathEditorAPIContext);
